'use client'

import Image from 'next/image'

import { cn } from './ui/utils'
import { useConfig } from './ConfigProvider'

/**
 * Brand mark: always a circle with a fine white ring when `framed`
 * (splash assets, landing, header). Readable on dark (ohyai) and light (ernest).
 */
export default function Logo({
  className,
  framed = true,
}: {
  className?: string
  /** When false, render the bare image (no circle ring). */
  framed?: boolean
}) {
  const { COMPANY_LOGO } = useConfig()
  const img = (
    <Image
      alt="Logo"
      className={cn("rounded-full object-cover", className || "h-12 w-12")}
      src={`/${COMPANY_LOGO}`}
      width={48}
      height={48}
    />
  )

  if (!framed) return img

  return (
    <div
      className={cn(
        "inline-flex shrink-0 cursor-pointer overflow-hidden rounded-full border border-white",
        "bg-gradient-to-r from-tertiary-base to-primary-base",
      )}
    >
      {img}
    </div>
  )
}
